module.exports = __webpack_public_path__ + "icon_grade-3ec67253b37908d2ab783f7225f20682.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/mailer/icon_grade.png
// module id = 274
// module chunks = 76